import RetrievalDocumentUploadForm from "./RetrievalDocumentUploadForm";
import { uploadToADLS } from "./TrusteeBondRetrieveShared";
import { RETRIEVE_PII_WITH_UPLOAD_FN } from "./bondRetrieveSharedPropTypes";

const TRUSTEE_SECTIONS = [
  { label: "Court Order", name: "courtOrder" },
  { label: "Last Will", name: "lastWill" },
  { label: "Other Document", name: "otherDocument" },
  { label: "Bond Application", name: "bondApp" },
  { label: "Bond Document", name: "bond" },
  { label: "Indemnity Agreement", name: "indemnity" },
  { label: "Cancellation Document", name: "cancellationDocument" },
  { label: "Endorsement Document", name: "endorsementDocument" },
  { label: "Endorsement POA Document", name: "endorsementPOADocument" },
  { label: "Credit Report Document", name: "creditDocument" },
  { label: "FCRA Document", name: "fcraDocument" },
];

const TrusteeDocumentUploadForm = (props) => (
  <RetrievalDocumentUploadForm
    {...props}
    uploadToADLS={props.uploadToADLS ?? uploadToADLS}
    sections={TRUSTEE_SECTIONS}
  />
);

TrusteeDocumentUploadForm.propTypes = RETRIEVE_PII_WITH_UPLOAD_FN;

export default TrusteeDocumentUploadForm;
